// extracted by mini-css-extract-plugin
module.exports = {"text":"practiceCardMenu_text__19YIr","overlay":"practiceCardMenu_overlay__1X1-d","fadeIn":"practiceCardMenu_fadeIn__1hOX3","fadeInOpacity":"practiceCardMenu_fadeInOpacity__14R2R"};